import Show from 'eGovProcedures/Show'

export default {
  Show,
}
